export default {
  "100.380.401": "Benutzerauthentifizierung fehlgeschlagen",
  "800.100.152": "Transaktion vom Authorisierungssystem abgelehnt",
  "100.396.101": "Abbruch durch Benutzer",
}
